import moment from 'moment';
import { apolloClient } from '@lib/apollo';
import {
  DELETE_TIMETABLE_TIMESLOT_CONFIGURATION,
  delete_timetable_timeslot_configurationMutation,
  delete_timetable_timeslot_configurationMutationVariables,
  INSERT_TIMETABLE_TIMESLOT_CONFIGURATION,
  insert_timetable_timeslot_configurationMutation,
  insert_timetable_timeslot_configurationMutationVariables,
  timetable_timeslot_configuration_insert_input,
} from '@app-types/graphql-types';
import { formatTimeSlotConfigurations, SaveTimeSlotConfigurationArgs } from '@modules/timetable';
import { logError } from '@lib/logger';

export const saveTimeSlotConfiguration = async ({
  timeSlotConfigurationsData,
  applyToAll,
  addToast,
  week,
  batchId,
  saveAsDefault,
}: SaveTimeSlotConfigurationArgs): Promise<void> => {
  try {
    const timetableTimeslotConfigurations: timetable_timeslot_configuration_insert_input[] =
      formatTimeSlotConfigurations({
        applyToAll,
        timeSlotConfigurationsData,
        week,
        batchId,
        saveAsDefault,
      });

    // If default, delete all existing defaults
    if (saveAsDefault) {
      await apolloClient.mutate<
        delete_timetable_timeslot_configurationMutation,
        delete_timetable_timeslot_configurationMutationVariables
      >({
        mutation: DELETE_TIMETABLE_TIMESLOT_CONFIGURATION,
        variables: {
          where: {
            default: {
              _eq: true,
            },
          },
        },
      });

      // Delete all existing for the current week
    } else {
      await apolloClient.mutate<
        delete_timetable_timeslot_configurationMutation,
        delete_timetable_timeslot_configurationMutationVariables
      >({
        mutation: DELETE_TIMETABLE_TIMESLOT_CONFIGURATION,
        variables: {
          where: {
            startTime: {
              _gte: moment().year(week.year()).week(week.week()).startOf('isoWeek'),
            },
            endTime: {
              _lte: moment().year(week.year()).week(week.week()).endOf('isoWeek'),
            },
            default: {
              _eq: false,
            },
            batchId: {
              _eq: batchId,
            },
          },
        },
      });
    }

    // Insert new data
    await apolloClient.mutate<
      insert_timetable_timeslot_configurationMutation,
      insert_timetable_timeslot_configurationMutationVariables
    >({
      mutation: INSERT_TIMETABLE_TIMESLOT_CONFIGURATION,
      variables: {
        objects: timetableTimeslotConfigurations,
      },
    });
  } catch (error) {
    addToast('Error. Something went wrong. Please try again.', {
      appearance: 'error',
      autoDismiss: true,
    });

    logError(error);
  }
};
